const map = {
	"./guidelines-for-starting-therapy/Guidelines for Starting Therapy.pdf": 5307,
	"./starter-pack/Starter pack.pdf": 669,
	"./terms-and-conditions/Therapist T&Cs - Membership Agreement.pdf": 7987
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5074;